import storeLocator from './store-locator';

export default function index() {
  storeLocator();
}
